import LowerThirds from '../../components/layout/graphics/LowerThirds';
import { Template, TemplateStore, TemplateType } from '../../models/templateClass';

const primaryColor = localStorage.getItem('primaryColor') || "#0D62C5";
const nametagsActive = JSON.parse(localStorage.getItem('nametagsActive') || 'true' );
const selectedTheme = localStorage.getItem('selectedTheme') || "lower_third1";

const initialState: TemplateStore =
  {
    brandsettings: {nametagsActive, primaryColor, selectedTheme},
    selectedLowerThird: null,
    lowerthirds: [],
    selectedTicker: null,
    tickers: [],
    templates: [],
    selectedLogos: [],
    logos: [],
  };

  export const SELECT_LOWERTHIRD = 'SELECT_LOWERTHIRD';
  export const DELETE_LOWERTHIRD = 'DELETE_LOWERTHIRD';
  export const SET_LOWERTHIRDS = 'SET_LOWERTHIRDS';

  export const SELECT_LOGO = 'SELECT_LOGO';
  export const SET_LOGO = 'SET_LOGO';
  export const SET_LOGO_POSITION = 'SET_LOGO_POSITION';

  export const SELECT_TICKER = 'SELECT_TICKER';
  export const DELETE_TICKER = 'DELETE_TICKER';
  export const SET_TICKERS = 'SET_TICKERS';

  export const SET_BRANDSETTINGS = 'SET_BRANDSETTINGS';
  export const ADD_TEMPLATE = 'ADD_TEMPLATE';
  export const REMOVE_TEMPLATE = 'REMOVE_TEMPLATE';
  export const REMOVE_TEMPLATE_TYPE = 'REMOVE_TEMPLATE_TYPE';

  export const REPLACE_LOWERTHIRD_IN_TEMPLATES = 'REPLACE_LOWERTHIRD_IN_TEMPLATES';
  export const REPLACE_TICKER_IN_TEMPLATES = 'REPLACE_TICKER_IN_TEMPLATES';

export const TemplateReducer = (state = initialState, action) => {
  switch (action.type) {

    // LOGOS
    case SELECT_LOGO: {
      return { ...state,  selectedLogos: action.payload};
    }
    case SET_LOGO: {
      return { ...state, logos: action.logos};
    }
    case SET_LOGO_POSITION: {
      return { ...state, logos: state.logos.map( lg => {
        if (lg.id === action.payload.logo.id) {
          return {...lg, position: action.payload.position}
        } else {
          return lg;
        }
      })};
    }


    // LOWERTHIRDS
    case SELECT_LOWERTHIRD: {
      return { ...state,  selectedLowerThird: action.payload};
    }

    case SET_LOWERTHIRDS: {
      return { ...state, lowerthirds: action.lowerthirds};
    }

    case DELETE_LOWERTHIRD: {
      return { ...state, lowerthirds: state.lowerthirds.filter(lt => lt.id !== action.payload.id)};
    }

    // TICKERS
    case SELECT_TICKER: {
      return { ...state,  selectedTicker: action.payload};
    }

    case SET_TICKERS: {
      return { ...state, tickers: action.tickers};
    }

    case DELETE_TICKER: {
      return { ...state, tickers: state.tickers.filter(lt => lt.id !== action.payload.id)};
    }

    // BRAND SETTINGS
    case SET_BRANDSETTINGS: {
      return { ...state, brandsettings: action.payload};
    }

    // TEMPLATE
    case ADD_TEMPLATE: {
      return { ...state, templates: [...state.templates, action.payload]};
    }

    case REPLACE_LOWERTHIRD_IN_TEMPLATES: {
      // only 1 lowerthird at the same time
      const newTemplates = state.templates.filter(templ => templ.type !== TemplateType.T_LOWERTHIRD);
      newTemplates.unshift(action.payload);
      return { ...state, templates: newTemplates};
    }

    case REPLACE_TICKER_IN_TEMPLATES: {
      // only 1 ticker at the same time
      const newTemplates = state.templates.filter(templ => templ.type !== TemplateType.T_TICKER);
      newTemplates.unshift(action.payload);
      return { ...state, templates: newTemplates};
    }

    case REMOVE_TEMPLATE: {
      // template id to remove is in the payload
      return { ...state, templates: state.templates.filter(templ => templ.id !== action.payload.id) };
    }
    case REMOVE_TEMPLATE_TYPE: {
      // template id to remove is in the payload
      return { ...state, templates: state.templates.filter(templ => templ.type !== action.payload.type) };
    }

    default:
      return state;
  }
};
